import React, { Component, useLayoutEffect } from "react";
import styles from "./Bank.module.css";
import { connect } from "react-redux";

import { Page } from "../../../helbest";
import Button from "../../components/ui/Button";
// import { bank_error_text } from "../../../base/env";

import ERROR from "../../../assets/images/base/cancel.png";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { useLangNavigate } from "../../../hooks/useLangNavigate";

function ErrorBank(props) {
  const navigate = useLangNavigate();

  useLayoutEffect(() => {
    if (!props.Login.is_login) {
      navigate("/");
    }
  }, []);

  return (
    <Page
      className="page-bank"
      title="Payment Result"
      back={true}
      address="/"
      customHeader={<HeaderBack url={"/"} title={"Payment Result"} />}
      showFooter={false}
      mobileContainer
      headerFix
      logo
    >
      <div className="container desktop-mode">
        <div className={`box-page ${styles.Box}`}>
          <div className="text-center payment-head-container">
            <img className="payment-img" src={ERROR} alt="" />
            <h4 className="payment-error">Payment Failed</h4>
          </div>
          <p className="payment-text" style={{ marginBottom: 0 }}>
            Oops! Something Wrong HiG
          </p>
          {/* <p className="payment-text mb-3">{`Transaction Number: ${this.props.match.params.code}`}</p> */}

          <div className="w-full flex center-content">
            <Button
              onClick={() => navigate("/cart")}
              style_width={"100%"}
              style={{ maxWidth: "200px" }}
              style_backgroundColor={"type-hot"}
              style_backgroundColor_hover={"type-hot-hover"}
              style_backgroundColor_active={"type-hot-active"}
            >
              Try Again
            </Button>
          </div>
        </div>
      </div>
    </Page>
  );
}

const mstp = (state) => ({
  Login: state.Login,
  Cart: state.Cart,
});
export default connect(mstp)(ErrorBank);
